import { ApiService } from '@/services/api.service'
import { getOneTimeParams } from '@/utils/helpers'

const BaseUrl = '/landing-pages'

const payload = (params) => ({
  ...params,
  ...getOneTimeParams()
})

export function detailLanding (params = {}) {
  return ApiService.get(`${BaseUrl}`, payload(params)).then((resp) => resp)
}
